/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_CategoryInputs */

const en_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const de_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const fr_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const es_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría`)
};

const it_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const nl_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorie`)
};

const pl_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategoria`)
};

const fi_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategoria`)
};

const da_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const sv_feedback_category = /** @type {(inputs: Feedback_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Feedback_CategoryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const feedback_category = /** @type {((inputs?: Feedback_CategoryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_CategoryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_feedback_category(inputs)
	if (locale === "fr") return fr_feedback_category(inputs)
	if (locale === "es") return es_feedback_category(inputs)
	if (locale === "it") return it_feedback_category(inputs)
	if (locale === "nl") return nl_feedback_category(inputs)
	if (locale === "pl") return pl_feedback_category(inputs)
	if (locale === "fi") return fi_feedback_category(inputs)
	if (locale === "da") return da_feedback_category(inputs)
	if (locale === "sv") return sv_feedback_category(inputs)
	return en_feedback_category(inputs)
});